import { render, staticRenderFns } from "./addPhoneNumberDialog.vue?vue&type=template&id=cf6cb20a&scoped=true"
import script from "./addPhoneNumberDialog.vue?vue&type=script&lang=ts"
export * from "./addPhoneNumberDialog.vue?vue&type=script&lang=ts"
import style0 from "./addPhoneNumberDialog.vue?vue&type=style&index=0&id=cf6cb20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6cb20a",
  null
  
)

export default component.exports